import React, { useState, useEffect } from 'react';
import CurrencyInput from "react-currency-input-field";
import Select from "react-select";
import api from '../../../../config/axios';
import Swal from 'sweetalert2';

import { FaRegSave, FaTimes } from 'react-icons/fa';
import { opcoesCFOP } from "../utils/opcoesCFOP";

const ProdutoModal = ({ onClose, produto, onProdutoAtualizado, fornecedores, localEstoque }) => {
    const [tituloModal, setTituloModal] = useState("");
    const [userType, setUserType] = useState('');
    const [formData, setFormData] = useState({
        nome: '',
        codigo_barras_ean: '',
        local_estoque_id: '',
        marca: '',
        linha: '',
        categoria: '',
        descricao: '',
        caracteristicas_produto_venda: false,
        caracteristicas_produto_consumo: false,
        caracteristicas_produto_solicitacao_saida_estoque: false,
        caracteristicas_produto_saida_negativa: false,
        custo: '',
        valor_venda: '',
        comissao: '',
        codigo_interno: '',
        prazo_em_dias: '',
        registro_saida: 'por unidade',
        estoque_minimo: 0,
        estoque_atual: 0,
        registrar_primeira_entrada_dados_nota_fiscal: false,
        registrar_descontar_produto_profissional: false,
        cfop: '',
        origem_produto: '',
        ncm: '',
        cest: '',
        considerar_fcp_emissao: false,
        codigo_icms_cst: '',
        valor_icms_cst: '',
        pis_cst: '',
        valor_pis_cst: '',
        cofins_cst: '',
        valor_cofins_cst: '',
        uso_proprio: 0,
        uso_interno: 0,
        descontar_uso_cliente: false,
        status: true
    });

    const codigosPISeCOFINS = [
        { value: 1, label: "1 - Operação Tributável com Alíquota Básica" },
        { value: 2, label: "2 - Operação Tributável com Alíquota Diferenciada" },
        { value: 3, label: "3 - Operação Tributável com Alíquota por Unidade de Medida de Produto" },
        { value: 4, label: "4 - Operação Tributável Monofásica – Revenda a Alíquota Zero" },
        { value: 5, label: "5 - Operação Tributável por Substituição Tributária" },
        { value: 6, label: "6 - Operação Tributável a Alíquota Zero" },
        { value: 7, label: "7 - Operação Isenta da Contribuição" },
        { value: 8, label: "8 - Operação sem Incidência da Contribuição" },
        { value: 9, label: "9 - Operação com Suspensão da Contribuição" },
        { value: 49, label: "49 - Outras Operações de Saída" },
        { value: 50, label: "50 - Operação com Direito a Crédito – Vinculado Exclusivamente a Receita Tributada no Mercado Interno" },
        { value: 51, label: "51 - Operação com Direito a Crédito – Vinculado Exclusivamente a Receita Não Tributada no Mercado Interno" },
        { value: 52, label: "52 - Operação com Direito a Crédito – Vinculado Exclusivamente a Receita de Exportação" },
        { value: 53, label: "53 - Operação com Direito a Crédito – Vinculado a Receitas Tributadas e Não-Tributadas no Mercado Interno" },
        { value: 54, label: "54 - Operação com Direito a Crédito – Vinculado a Receitas Tributadas no Mercado Interno e de Exportação" },
        { value: 55, label: "55 - Operação com Direito a Crédito – Vinculado a Receitas Não-Tributadas no Mercado Interno e de Exportação" },
        { value: 56, label: "56 - Operação com Direito a Crédito – Vinculado a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação" },
        { value: 60, label: "60 - Crédito Presumido – Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno" },
        { value: 61, label: "61 - Crédito Presumido – Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno" },
        { value: 62, label: "62 - Crédito Presumido – Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação" },
        { value: 63, label: "63 - Crédito Presumido – Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno" },
        { value: 64, label: "64 - Crédito Presumido – Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação" },
        { value: 65, label: "65 - Crédito Presumido – Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação" },
        { value: 66, label: "66 - Crédito Presumido – Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação" },
        { value: 67, label: "67 - Crédito Presumido – Outras Operações" },
        { value: 70, label: "70 - Operação de Aquisição sem Direito a Crédito" },
        { value: 71, label: "71 - Operação de Aquisição com Isenção" },
        { value: 72, label: "72 - Operação de Aquisição com Suspensão" },
        { value: 73, label: "73 - Operação de Aquisição a Alíquota Zero" },
        { value: 74, label: "74 - Operação de Aquisição sem Incidência da Contribuição" },
        { value: 75, label: "75 - Operação de Aquisição por Substituição Tributária" },
        { value: 98, label: "98 - Outras Operações de Entrada" },
        { value: 99, label: "99 - Outras Operações" },
    ];

    const opcoesOrigemProdutos = [
        { value: '0', label: "Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8." },
        { value: '1', label: "Estrangeira - Importação direta, exceto a indicada no código 6." },
        { value: '2', label: "Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7." },
        { value: '3', label: "Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% (quarenta por cento) e inferior ou igual a 70% (setenta por cento)." },
        { value: '4', label: "Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos (PPB) do que tratam o Decreto-Lei n° 288/1967, e as Leis n°s 8.248/1991, 8.380/1991, 10.176/2001 e 11.484/2007." },
        { value: '5', label: "Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40% (quarenta por cento)." },
        { value: '6', label: "Estrangeira - Importação direta, sem similar nacional, constante em lista da Resolução CAMEX e gás natural." },
        { value: '7', label: "Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista da Resolução CAMEX e gás natural." },
        { value: '8', label: "Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70% (setenta por cento)." }
    ];

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            whiteSpace: "pre-line",
        }),
        option: (provided) => ({
            ...provided,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
        }),
    };

    useEffect(() => {
        const userDataArmazenado = localStorage.getItem('userData');
        if (userDataArmazenado) {
            const userData = JSON.parse(userDataArmazenado);
            if (userData.unidade_designacao_id && userData.gestora_designacao_id) {
                setUserType('colaborador');
            } else if (userData.gestora_designacao_id) {
                setUserType('gestor');
            } else {
                setUserType('master');
            }
        }
        
        if (produto != null) {
            setFormData({
                ...produto,
                comissao: (produto.comissao) ? produto.comissao.toString() + "%" : '',
                valor_icms_cst: (produto.valor_icms_cst) ? produto.valor_icms_cst.toString() + "%" : '',
                valor_pis_cst: (produto.valor_pis_cst) ? produto.valor_pis_cst.toString() + "%" : '',
                valor_cofins_cst: (produto.valor_cofins_cst) ? produto.valor_cofins_cst.toString() + "%" : ''
            });
            setTituloModal('Editar Produto');
        }
        else setTituloModal('Novo Produto');
    }, [produto]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData((prevState) => {
            if (name === "comissao" || name == 'valor_icms_cst' || name == 'valor_pis_cst' || name == 'valor_cofins_cst') {
                let inputValue = value.replace(/[^0-9.]/g, "");
                if (parseFloat(inputValue) > 100) inputValue = "100";

                return {
                    ...prevState,
                    [name]: inputValue + "%"
                };
            }

            return {
                ...prevState,
                [name]: type === "checkbox" ? checked : value,
            };
        });
    };

    const handleChangeSelect = (selectedOption, { name }) => {
        setFormData({
            ...formData,
            [name]: selectedOption ? selectedOption.value : "",
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const camposObrigatorios = [
            { campo: 'nome', label: 'Nome' },
            { campo: 'codigo_barras_ean', label: 'Código de Barras (EAN)' },
            { campo: 'local_estoque_id', label: 'Local Estoque' },
            { campo: 'marca', label: 'Marca' },
            { campo: 'categoria', label: 'Categoria' },
            { campo: 'custo', label: 'Custo' },
            { campo: 'valor_venda', label: 'Valor de Venda' },
            { campo: 'codigo_interno', label: 'Código Interno' },
            { campo: 'id_pessoa_fornecedor', label: 'Fornecedor' },
            { campo: 'prazo_em_dias', label: 'Prazo de Entrega em' },
            { campo: 'registro_saida', label: 'Registro de Saída' },

        ];

        if (!formData.caracteristicas_produto_consumo) {
            camposObrigatorios.push({ campo: 'comissao', label: 'Comissão' });
        }

        if (formData.registrar_primeira_entrada_dados_nota_fiscal) {
            camposObrigatorios.push(
                { campo: 'cfop', label: 'CFOP' },
                { campo: 'origem_produto', label: 'Origem Produto' },
                { campo: 'ncm', label: 'NCM' },
                { campo: 'cest', label: 'Cest' },
            )
        }
        else {
            formData.cfop = 0;
            formData.origem_produto = 0;
            formData.ncm = '';
            formData.cest = '';
            formData.considerar_fcp_emissao = false;
        }

        if (formData.considerar_fcp_emissao) {
            camposObrigatorios.push(
                { campo: 'codigo_icms_cst', label: 'Código ICMS-CST' },
                { campo: 'pis_cst', label: 'Código PIS-CST' },
                { campo: 'cofins_cst', label: 'Código COFINS-CST' }
            )
        }
        else {
            formData.codigo_icms_cst = 0;
            formData.valor_icms_cst = '';
            formData.pis_cst = 0;
            formData.valor_pis_cst = '';
            formData.cofins_cst = 0;
            formData.valor_cofins_cst = '';
        }

        if (!formData.registrar_descontar_produto_profissional) {
            formData.uso_proprio = 0;
            formData.uso_interno = 0;
            formData.descontar_uso_cliente = false;
        }

        const camposInvalidos = camposObrigatorios.filter(({ campo }) => {
            const valor = formData[campo];
            
            if (campo == 'codigo_icms_cst') return !valor.toString();
            if (typeof valor === 'string') return !valor.trim();
            if (typeof valor === 'object' && valor !== null) return !valor.value;
            return !valor;
        });

        if (camposInvalidos.length > 0) {
            Swal.fire(
                'Erro',
                `Os seguintes campos são obrigatórios: ${camposInvalidos.map(c => c.label).join(', ')}`,
                'error'
            );
            return;
        }

        const data = {
            ...formData,
            comissao: formData.comissao && formData.comissao.trim() !== '' && formData.comissao !== '%' 
                ? parseFloat(formData.comissao.replace(/[^0-9.]/g, "")) 
                : null,
            custo: parseFloat(formData.custo.replace(',', '.')),
            valor_venda: parseFloat(formData.valor_venda.replace(',', '.')),
            valor_icms_cst: (formData.valor_icms_cst) ? parseFloat(formData.valor_icms_cst.replace(/[^0-9.]/g, "")) : 0,
            valor_pis_cst: (formData.valor_pis_cst) ? parseFloat(formData.valor_pis_cst.replace(/[^0-9.]/g, "")) : 0,
            valor_cofins_cst: (formData.valor_cofins_cst) ? parseFloat(formData.valor_cofins_cst.replace(/[^0-9.]/g, "")) : 0,
            estoque_minimo: formData.estoque_minimo ? parseInt(formData.estoque_minimo) : 0,
            estoque_atual: formData.estoque_atual ? parseInt(formData.estoque_atual) : 0
        };

        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            if (produto != null) {
                await api.put(`/produtos/${produto.id_produto}`, data);
            }
            else {
                await api.post(`/produtos`, data);
            }

            onProdutoAtualizado();
            onClose();
            Swal.fire('Sucesso', 'Produto salvo com sucesso!', 'success');
        }
        catch (error) {
            Swal.close();
            Swal.fire('Erro', `${error.response.data.message}`, 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">{tituloModal}</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row mt-3">
                                <div className="col-lg-8 col-12">
                                    <label className="form-label fw-bold">Nome</label>
                                    <input
                                        type="text"
                                        name="nome"
                                        className="form-control"
                                        autoComplete="off"
                                        value={formData.nome.toUpperCase()}
                                        onChange={handleChange}
                                        disabled={userType === 'colaborador'}
                                        required
                                    />
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Código de Barras (EAN)</label>
                                    <input
                                        type="text"
                                        name="codigo_barras_ean"
                                        className="form-control"
                                        autoComplete="off"
                                        value={formData.codigo_barras_ean}
                                        onChange={handleChange}
                                        disabled={userType === 'colaborador'}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-lg-6 col-12">
                                    <label className="form-label fw-bold">Local Estoque</label>
                                    <select
                                        name="local_estoque_id"
                                        className="form-control"
                                        value={formData.local_estoque_id}
                                        onChange={handleChange}
                                        disabled={userType === 'colaborador'}
                                    >
                                        <option value="" hidden>Selecione...</option>
                                        {localEstoque.map((option, index) => (
                                            <option key={index} value={option.id}>
                                                {option.nome}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Marca</label>
                                    <input
                                        type="text"
                                        name="marca"
                                        className="form-control"
                                        autoComplete="off"
                                        value={formData.marca}
                                        onChange={handleChange}
                                        disabled={userType === 'colaborador'}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-lg-4 col-12">
                                    <label className="form-label fw-bold">Status</label>
                                    <select
                                        name="status"
                                        className="form-control"
                                        value={formData.status}
                                        onChange={(e) => setFormData({...formData, status: e.target.value === 'true'})}
                                        disabled={userType === 'colaborador'}
                                    >
                                        <option value={true}>Ativo</option>
                                        <option value={false}>Inativo</option>
                                    </select>
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Linha</label>
                                    <input
                                        type="text"
                                        name="linha"
                                        className="form-control"
                                        autoComplete="off"
                                        value={formData.linha}
                                        onChange={handleChange}
                                        disabled={userType === 'colaborador'}
                                        required
                                    />
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Categoria</label>
                                    <input
                                        type="text"
                                        name="categoria"
                                        className="form-control"
                                        autoComplete="off"
                                        value={formData.categoria}
                                        onChange={handleChange}
                                        disabled={userType === 'colaborador'}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Descrição</label>
                                    <textarea
                                        name="descricao"
                                        rows="4"
                                        className="form-control"
                                        autoComplete="off"
                                        value={formData.descricao}
                                        onChange={handleChange}
                                        disabled={userType === 'colaborador'}
                                    ></textarea>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Característica do Produto</label>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="caracteristicas_produto_venda"
                                            checked={formData.caracteristicas_produto_venda}
                                            onChange={handleChange}
                                            disabled={userType === 'colaborador'}
                                        />
                                        <label className="form-check-label">Venda</label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="caracteristicas_produto_consumo"
                                            checked={formData.caracteristicas_produto_consumo}
                                            onChange={handleChange}
                                            disabled={userType === 'colaborador'}
                                        />
                                        <label className="form-check-label">Consumo</label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="caracteristicas_produto_solicitacao_saida_estoque"
                                            checked={formData.caracteristicas_produto_solicitacao_saida_estoque}
                                            onChange={handleChange}
                                            disabled={userType === 'colaborador'}
                                        />
                                        <label className="form-check-label">Solicitação de Saída do Estoque</label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="caracteristicas_produto_saida_negativa"
                                            checked={formData.caracteristicas_produto_saida_negativa}
                                            onChange={handleChange}
                                            disabled={userType === 'colaborador'}
                                        />
                                        <label className="form-check-label">Proibição de Saída Negativa</label>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-lg-4 col-12">
                                    <label className="form-label fw-bold">Custo</label>
                                    <CurrencyInput
                                        name="custo"
                                        placeholder="R$ 0,00"
                                        value={formData.custo}
                                        decimalsLimit={2}
                                        decimalSeparator=","
                                        groupSeparator="."
                                        prefix="R$ "
                                        className="form-control"
                                        autoComplete="off"
                                        onValueChange={(value) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                custo: value,
                                            }))
                                        }
                                    />
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Valor de Venda</label>
                                    <CurrencyInput
                                        name="valor_venda"
                                        placeholder="R$ 0,00"
                                        value={formData.valor_venda}
                                        decimalsLimit={2}
                                        decimalSeparator=","
                                        groupSeparator="."
                                        prefix="R$ "
                                        className="form-control"
                                        autoComplete="off"
                                        onValueChange={(value) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                valor_venda: value,
                                            }))
                                        }
                                    />
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Comissão</label>
                                    <input
                                        className="form-control"
                                        name="comissao"
                                        autoComplete="off"
                                        value={formData.comissao}
                                        onChange={handleChange}
                                        placeholder="0%"
                                    />
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-lg-4 col-12">
                                    <label className="form-label fw-bold">Código Interno do Produto</label>
                                    <input
                                        type="text"
                                        name="codigo_interno"
                                        className="form-control"
                                        value={formData.codigo_interno}
                                        onChange={handleChange}
                                        disabled={userType === 'colaborador'}
                                    />
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Fornecedor</label>
                                    <select
                                        name="id_pessoa_fornecedor"
                                        className="form-control"
                                        value={formData.id_pessoa_fornecedor}
                                        onChange={handleChange}
                                        disabled={userType === 'colaborador'}
                                    >
                                        <option value="" hidden>Selecione...</option>
                                        {fornecedores.map((option, index) => (
                                            <option key={index} value={option.id}>
                                                {option.dadosFornecedor.nome_fantasia}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Prazo de Entrega em</label>
                                    <div className="input-group">
                                        <input
                                            type="number"
                                            name="prazo_em_dias"
                                            className="form-control"
                                            autoComplete="off"
                                            value={formData.prazo_em_dias}
                                            onChange={handleChange}
                                            disabled={userType === 'colaborador'}
                                            required
                                        />
                                        <span className="input-group-text">dias</span>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-lg-4 col-12">
                                    <label className="form-label fw-bold">Registro de Saída</label>
                                    <select
                                        name="registro_saida"
                                        className="form-control"
                                        value={formData.registro_saida}
                                        onChange={handleChange}
                                        disabled={userType === 'colaborador'}
                                    >
                                        <option value="por unidade">por unidade</option>
                                        <option value="por dosagem">por dosagem</option>
                                        <option value="por ml (mililitro)">por ml (mililitro)</option>
                                        <option value="por g (gramas)">por g (gramas)</option>
                                        <option value="por dg (decigramas)">por dg (decigramas)</option>
                                        <option value="por cm (centímetro)">por cm (centímetro)</option>
                                        <option value="por caixa">por caixa</option>
                                        <option value="por pacote">por pacote</option>
                                    </select>
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Estoque Mínimo</label>
                                    <div className="input-group">
                                        <input
                                            type="number"
                                            name="estoque_minimo"
                                            className="form-control"
                                            autoComplete="off"
                                            value={formData.estoque_minimo}
                                            onChange={handleChange}
                                            disabled={userType === 'colaborador'}
                                        />
                                        <span className="input-group-text">unidades</span>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Estoque Atual</label>
                                    <input
                                        type="number"
                                        name="estoque_atual"
                                        className="form-control"
                                        autoComplete="off"
                                        value={formData.estoque_atual}
                                        onChange={handleChange}
                                        disabled={userType === 'colaborador'}
                                    />
                                </div>
                            </div>
                            <div className="row mt-5 p-4 bg-info-custom">
                                <div className="col-12">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="registrar_primeira_entrada_dados_nota_fiscal"
                                            checked={formData.registrar_primeira_entrada_dados_nota_fiscal}
                                            onChange={handleChange}
                                            disabled={userType === 'colaborador'}
                                        />
                                        <label className="form-check-label">Preencher Dados de Nota Fiscal</label>
                                    </div>
                                </div>
                                {formData.registrar_primeira_entrada_dados_nota_fiscal && (
                                    <div>
                                        <div className="row mt-3">
                                            <div className="col-lg-6 col-12">
                                                <label className="form-label fw-bold">CFOP</label>
                                                <Select
                                                    options={opcoesCFOP}
                                                    styles={customStyles}
                                                    name="cfop"
                                                    placeholder="Selecione..."
                                                    value={opcoesCFOP.find(option => option.value === formData.cfop)}
                                                    onChange={handleChangeSelect}
                                                    isDisabled={userType === 'colaborador'}
                                                />
                                            </div>
                                            <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                                <label className="form-label fw-bold">Origem Produto</label>
                                                <Select
                                                    options={opcoesOrigemProdutos}
                                                    styles={customStyles}
                                                    name="origem_produto"
                                                    placeholder="Selecione..."
                                                    value={opcoesOrigemProdutos.find(option => option.value === formData.origem_produto)}
                                                    onChange={handleChangeSelect}
                                                    isDisabled={userType === 'colaborador'}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-lg-6 col-12">
                                                <label className="form-label fw-bold">NCM</label>
                                                <input
                                                    type="text"
                                                    name="ncm"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    value={formData.ncm}
                                                    onChange={handleChange}
                                                    disabled={userType === 'colaborador'}
                                                    required
                                                />
                                            </div>
                                            <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                                <label className="form-label fw-bold">CEST</label>
                                                <input
                                                    type="text"
                                                    name="cest"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    value={formData.cest}
                                                    onChange={handleChange}
                                                    disabled={userType === 'colaborador'}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-12">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        name="considerar_fcp_emissao"
                                                        checked={formData.considerar_fcp_emissao}
                                                        onChange={handleChange}
                                                        disabled={userType === 'colaborador'}
                                                    />
                                                    <label className="form-check-label">Considera FCP na Emissão</label>
                                                </div>
                                            </div>
                                        </div>
                                        {formData.considerar_fcp_emissao && (
                                            <div>
                                                <div className="row mt-3">
                                                    <div className="col-lg-6 col-12">
                                                        <label className="form-label fw-bold">Código ICMS-CST</label>
                                                        <select
                                                            name="codigo_icms_cst"
                                                            className="form-control"
                                                            value={formData.codigo_icms_cst}
                                                            onChange={handleChange}
                                                            disabled={userType === 'colaborador'}
                                                        >
                                                            <option value="" hidden>Selecione...</option>
                                                            <option value="0">00 - Tributada integralmente</option>
                                                            <option value="10">10 - Tributada e com cobrança do ICMS por substituição tributária</option>
                                                            <option value="20">20 - Com redução de base de cálculo</option>
                                                            <option value="30">30 - Isenta ou não tributada e com cobrança do ICMS por substituição tributária</option>
                                                            <option value="40">40 - Isenta</option>
                                                            <option value="41">41 - Não tributada</option>
                                                            <option value="50">50 - Suspensão</option>
                                                            <option value="51">51 - Diferimento</option>
                                                            <option value="60">60 - ICMS cobrado anteriormente por substituição tributária</option>
                                                            <option value="70">70 - Com redução de base de cálculo e cobrança do ICMS por substituição tributária</option>
                                                            <option value="90">90 - Outras</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                                        <label className="form-label fw-bold">Valor ICMS-CST</label>
                                                        <input
                                                            className="form-control"
                                                            name="valor_icms_cst"
                                                            autoComplete="off"
                                                            value={formData.valor_icms_cst}
                                                            onChange={handleChange}
                                                            disabled={userType === 'colaborador'}
                                                            placeholder="0%"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <div className="col-lg-6 col-12">
                                                        <label className="form-label fw-bold">Código PIS-CST</label>
                                                        <Select
                                                            options={codigosPISeCOFINS}
                                                            styles={customStyles}
                                                            name="pis_cst"
                                                            placeholder="Selecione..."
                                                            value={codigosPISeCOFINS.find(option => option.value === formData.pis_cst)}
                                                            onChange={handleChangeSelect}
                                                            isDisabled={userType === 'colaborador'}
                                                        />
                                                    </div>
                                                    <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                                        <label className="form-label fw-bold">Valor PIS-CST</label>
                                                        <input
                                                            className="form-control"
                                                            name="valor_pis_cst"
                                                            autoComplete="off"
                                                            value={formData.valor_pis_cst}
                                                            onChange={handleChange}
                                                            disabled={userType === 'colaborador'}
                                                            placeholder="0%"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <div className="col-lg-6 col-12">
                                                        <label className="form-label fw-bold">Código COFINS-CST</label>
                                                        <Select
                                                            options={codigosPISeCOFINS}
                                                            styles={customStyles}
                                                            name="cofins_cst"
                                                            placeholder="Selecione..."
                                                            value={codigosPISeCOFINS.find(option => option.value === formData.cofins_cst)}
                                                            onChange={handleChangeSelect}
                                                            isDisabled={userType === 'colaborador'}
                                                        />
                                                    </div>
                                                    <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                                        <label className="form-label fw-bold">Valor COFINS-CST</label>
                                                        <input
                                                            className="form-control"
                                                            name="valor_cofins_cst"
                                                            autoComplete="off"
                                                            value={formData.valor_cofins_cst}
                                                            onChange={handleChange}
                                                            disabled={userType === 'colaborador'}
                                                            placeholder="0%"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            <div className="row mt-3 p-4 bg-info-custom">
                                <div className="col-12">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="registrar_descontar_produto_profissional"
                                            checked={formData.registrar_descontar_produto_profissional}
                                            onChange={handleChange}
                                            disabled={userType === 'colaborador'}
                                        />
                                        <label className="form-check-label">Descontar Produto do Profissional</label>
                                    </div>
                                </div>
                                {formData.registrar_descontar_produto_profissional && (
                                    <div>
                                        <div className="row mt-3">
                                            <div className="col-lg-6 col-12">
                                                <label className="form-label fw-bold">Uso Próprio</label>
                                                <CurrencyInput
                                                    name="uso_proprio"
                                                    placeholder="R$ 0,00"
                                                    value={formData.uso_proprio}
                                                    decimalsLimit={2}
                                                    decimalSeparator=","
                                                    groupSeparator="."
                                                    prefix="R$ "
                                                    className="form-control"
                                                    autoComplete="off"
                                                    disabled={userType === 'colaborador'}
                                                    onValueChange={(value) =>
                                                        setFormData((prevState) => ({
                                                            ...prevState,
                                                            uso_proprio: value,
                                                        }))
                                                    }
                                                />
                                            </div>
                                            <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                                <label className="form-label fw-bold">Uso Interno</label>
                                                <CurrencyInput
                                                    name="uso_interno"
                                                    placeholder="R$ 0,00"
                                                    value={formData.uso_interno}
                                                    decimalsLimit={2}
                                                    decimalSeparator=","
                                                    groupSeparator="."
                                                    prefix="R$ "
                                                    className="form-control"
                                                    autoComplete="off"
                                                    disabled={userType === 'colaborador'}
                                                    onValueChange={(value) =>
                                                        setFormData((prevState) => ({
                                                            ...prevState,
                                                            uso_interno: value,
                                                        }))
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-12">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        name="descontar_uso_cliente"
                                                        checked={formData.descontar_uso_cliente}
                                                        onChange={handleChange}
                                                        disabled={userType === 'colaborador'}
                                                    />
                                                    <label className="form-check-label">Descontar Uso do Cliente</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                                <button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSubmit}>
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default ProdutoModal;
